// Datei: src/components/icons/SchatztruheIcon.js (Mit Schimmer + Hover Animation)

import React from 'react';

export function SchatztruheIcon({ src, alt = "Schatztruhe", type = "normal" }) {
    const shimmerAnimation = {
        animation: 'shimmer 2s infinite',
        background: 'linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.5) 50%, rgba(255,255,255,0) 100%)',
        backgroundSize: '200% 100%',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        color: 'transparent'
    };

    return (
        <img
            src={src}
            alt={alt}
            style={{
                width: '80px',
                height: 'auto',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease, filter 0.3s ease',
                borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                cursor: 'pointer',
                filter: type === 'diamond' ? 'brightness(1.2)' : 'none',
                ...(type === 'diamond' ? shimmerAnimation : {})
            }}
            onMouseEnter={e => {
                e.currentTarget.style.transform = 'scale(1.15)';
                e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.3)';
            }}
            onMouseLeave={e => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
            }}
        />
    );
}

// Globale CSS Animation hinzufügen (kannst du in style.css oder global einfügen)

/*
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
*/
